import { useState } from 'react';
import { IconButton, IconName } from '@optimus-web/core';
import { WithBillId } from '@mews-commander/types';
import { useScope } from '@mews/framework';
import { isCurrentEnterpriseBillEmpty } from '@mews-commander/legacy-entities/src/selectors';
import { isBillVirtual } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { deleteBill } from '../../../actions/bills';
import { withActiveWindowLoader } from '../../../../../core';

export const DeleteBillButton = ({ billId }: WithBillId) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useCommanderThunkDispatch();
    const scope = useScope() ?? '';

    const enabled = useCommanderSelector((state) => isCurrentEnterpriseBillEmpty(state, { billId }));
    const isVirtualBill = useCommanderSelector((state) => isBillVirtual(state, { id: billId }));

    if (!enabled || isVirtualBill) {
        return null;
    }

    const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true);
        e.stopPropagation();

        try {
            await withActiveWindowLoader(() => dispatch(deleteBill({ billId, scope })));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <IconButton
            icon={IconName.Delete}
            onClick={handleClick}
            size="small"
            variant="ghost"
            loading={isLoading}
            type="submit"
        />
    );
};
